import { UserActions } from '@next/core-lib/user';
import { createReducer, on } from '@ngrx/store';

import { ProductionState } from '../../models/production.model';
import * as ProductionActions from '../actions/production.actions';

export const initialState: ProductionState = {
  productionList: null,
  selectedProduction: null,
};

export const productionReducer = createReducer<ProductionState>(
  initialState,
  on(ProductionActions.loadProductionListSuccess, (state, { productionList }) => ({
    ...state,
    productionList,
  })),
  on(ProductionActions.setSelectedProduction, (state, { production }) => ({
    ...state,
    selectedProduction: production,
  })),
  on(UserActions.relationshipSelected, () => initialState),
);
